import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { PrimeNG } from 'primeng/config';
import { IdleTimeoutService } from '@/core/auth/idle-timeout.service';
import { UserService } from '@/core/service/user.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private primengConfig: PrimeNG,
    private idleService: IdleTimeoutService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.checkAuthAndStartWatching();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        const appName = 'Sigos';
        const pageTitle = data['title'] ? data['title'] : 'Home';
        this.titleService.setTitle(`${appName} - ${pageTitle}`);
        this.checkAuthAndStartWatching();
      });

    this.primengConfig.setTranslation({
      firstDayOfWeek: 0,
      dayNames: [
        'domingo', 'segunda-feira', 'terça-feira', 'quarta-feira',
        'quinta-feira', 'sexta-feira', 'sábado'
      ],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ],
      monthNamesShort: [
        'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
        'jul', 'ago', 'set', 'out', 'nov', 'dez'
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sem',
      noFilter: "Sem filtro",
      apply: 'Aplicar',
      accept: 'Sim',
      reject: 'Não'
    });

  }

  private checkAuthAndStartWatching() {
    const token = this.userService.isLogged();
    const isLoginPage = this.router.url.includes('/login');

    if (token && !isLoginPage) {
      this.idleService.startWatching();
    } else {
      this.idleService.stopWatching();
    }
  }

  ngOnDestroy() {
    this.idleService.stopWatching();
  }
}
